import React from 'react'
import Button, { ButtonLink, ButtonTheme } from './Button'
import Icon, { Icons } from './Icon'
import classNames from 'classnames'

type Icon = {
  name: Icons
  className?: string
}

const actionClassName =
  'max-md:px-[15px] md:px-[25px] !py-[15px] hover:!scale-[1.12]'

type Props = {
  href: string
  disabled?: boolean
  theme?: ButtonTheme
  ariaLabel: string
  icon: Icon
  subLabel?: string
  newTab?: boolean
}

export default function IconLink({
  ariaLabel,
  href,
  icon,
  disabled,
  subLabel,
  theme = 'secondary',
  newTab = true
}: Props) {
  return (
    <div>
      <ButtonLink
        ariaLabel={ariaLabel}
        theme={theme}
        disabled={disabled}
        href={href}
        className={actionClassName}
        newTab={newTab}
      >
        <IconActionIcon icon={icon} />
      </ButtonLink>
      <SubLabel value={subLabel} />
    </div>
  )
}

const IconActionIcon = ({ icon }: { icon: Icon }) => {
  let iconSizing = ''

  switch (icon.name) {
    case 'expand':
      iconSizing = 'w-[22px] h-[22px]'
      break
    case 'download':
    case 'blockchainV2':
      iconSizing = 'w-[24px] h-[24px]'
      break
    default:
      break
  }
  return (
    <Icon
      name={icon.name}
      className={classNames('w-[20px] h-[20px]', icon.className, iconSizing)}
    />
  )
}

interface IconActionProps {
  icon: Icon
  theme?: ButtonTheme
  disabled?: boolean
  subLabel?: string
  onClick?: () => void
}

export const IconAction = ({
  icon,
  theme = 'secondary',
  disabled,
  subLabel,
  onClick
}: IconActionProps) => {
  return (
    <div>
      <Button
        onClick={onClick}
        theme={theme}
        disabled={disabled}
        className={classNames(actionClassName, 'w-full')}
      >
        <IconActionIcon icon={icon} />
      </Button>

      <SubLabel value={subLabel} />
    </div>
  )
}

const SubLabel = ({ value }: { value: string }) => {
  if (!value) return null

  return (
    <div className="text-center w-full body-xs text-gray-300 mt-1">{value}</div>
  )
}
